"use client";

import { Screen } from "../_skins/registry";

/* 🔴 껍데기입니다 — 화면은 활성 스킨의 `login` (`_skins/registry.tsx`). */
export default function LoginPage() {
  return <Screen name="login" />;
}
